import _ from 'lodash'

export const arrayToDocumentTypeList = function(docs) {
  let docsOrder = docs.map(d => {
    return objectToDocumentType(d)
  })

  return _.orderBy(docsOrder, ['nombreOrden'], ['asc'])
}

export const objectToDocumentType = function(doc) {
  return {
    ...doc,
    nombreOrden: doc.nombre
      .toLowerCase()
      .replace('á', 'a')
      .replace('é', 'e')
      .replace('í', 'i')
      .replace('ó', 'o')
      .replace('ú', 'u'),
    descripcion: doc.clave + '-' + doc.nombre,
    activoTxt: doc.activo ? 'Activo' : 'Inactivo'
  }
}
